<div ngModelGroup="dadosPessoais">
    <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
    <div fxLayout="row" fxFlexFill fxLayoutGap="20px">
        <div fxLayout="column" fxFlex>
            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                    <input matInput
                           [(ngModel)]="pessoaFisica.cpf"
                           name="cpf" (blur)="consultaPessoaFisica()"
                           placeholder="CPF:"
                           [textMask]="{mask: mascaraCpf}"
                           [cpfValidator]>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex fxFlexOffset="20px">
                    <input matInput maxlength="255" name="nome" placeholder="Nome Completo:"
                           [(ngModel)]="pessoaFisica.nome" required>
                </mat-form-field>

                <mat-form-field fxFlex>
                    <input matInput maxlength="255" name="nomeSocial" placeholder="Nome Social:"
                           [(ngModel)]="pessoaFisica.nomeSocial">
                </mat-form-field>

            </div>

        </div>
        <div fxLayout="column" fxLayoutGap="20px" style="text-align: end; flex-shrink: 0;">
            <button type="button" name="fotoPerfil" mat-raised-button class="botao" (click)="uploadFile.click()"
                    [style.background-image]="getBackground()">
                <mat-icon class="nao-foto"></mat-icon>
            </button>
            <input #uploadFile type="file" style="display:none;" (change)="fileChangeEvent($event)"/>
        </div>

    </div>

    <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field fxFlexOffset="20px" fxFlex="20">
            <input matInput name="dataNascimento"
                   [matDatepicker]="dataNascimento"
                   (input)="onMascaraDataInput($event)"
                   placeholder="Data de Nascimento"
                   [(ngModel)]="pessoaFisica.dataNascimento">
            <mat-datepicker-toggle matSuffix [for]="dataNascimento"></mat-datepicker-toggle>
            <mat-datepicker #dataNascimento></mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex="30">
            <input matInput placeholder="Idade" [value]="idadeFormatada" readonly style="overflow: hidden">
        </mat-form-field>

        <combo-sexo fxFlex="25"
                    [selecionado]="pessoaFisica.sexo"
                    [obrigatorio]="false"
                    (valorChange)="onSexoChange($event)">
        </combo-sexo>

        <combo-raca fxFlex="20"
                   [selecionado]="pessoaFisica.raca"
                   [obrigatorio]="false"
                   (valorChange)="onRacaChange($event)">
        </combo-raca>
      </div>

        <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field fxFlexOffset="20px" fxFlex="75">
            <input #campoCidade
                   matInput maxlength="200"
                   [(ngModel)]="pessoaFisica.cidadeNaturalidade"
                   name="cidadeNaturalidade"
                   placeholder="Cidade Naturalidade">
            <mat-hint align="end">{{ campoCidade.value.length }} / 200</mat-hint>
        </mat-form-field>

        <combo-uf fxFlex="25"
                  [selecionado]="pessoaFisica.ufNascimento"
                  [obrigatorio]="false"
                  (valorChange)="onUfChange($event)">
        </combo-uf>
    </div>


    <div fxLayout="row" style="margin-bottom: 20px" class="espaco" fxLayoutAlign="start start" fxLayoutGap="20px" fxFlexFill>
        <div id="row_dados" fxFlex="100%" fxFlexFill>
            <!-- ETAPA 1 - FILIAÇÃO -->
            <mat-toolbar class="titulopartes">Filiação</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                <mat-form-field fxFlex fxFlexOffset="20px">
                    <input matInput maxlength="200" name="nomeMae" placeholder="Nome da Mãe:"
                           [(ngModel)]="pessoaFisica.nomeMae">
                </mat-form-field>

                <mat-form-field fxFlex>
                    <input matInput maxlength="200" name="nomePai" placeholder="Nome do Pai:"
                           [(ngModel)]="pessoaFisica.nomePai">
                </mat-form-field>

            </div>

            <mat-toolbar class="titulopartes">Outras Informações</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>

                <combo-estado-civil fxFlex="20%" fxFlexOffset="20px"
                                   [selecionado]="pessoaFisica.estadoCivil"
                                   [obrigatorio]="false"
                                   (valorChange)="onEstadoCivilChange($event)">
                </combo-estado-civil>


                <combo-tipo-sangue fxFlex="20%"
                                   [selecionado]="pessoaFisica.tipoSangue"
                                   [obrigatorio]="false"
                                   (valorChange)="onTipoSangueChange($event)">
                </combo-tipo-sangue>

                <!-- <mat-form-field fxFlex= "20%" fxFlexOffset="20px" >
                    <input  matInput maxlength="2"  name="qtPessoasResidemFamilia"
                       placeholder="Quantidade Pessoas Residem na Família:" [(ngModel)]="pessoaFisica.qtPessoasResidemFamilia" >
                </mat-form-field> -->

            </div>

            <!-- CONDIÇÕES DE SAÚDE -->
            <mat-toolbar class="titulopartes">Condição de Saúde</mat-toolbar>

            <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
                <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
                    <mat-label>Descrição de problemas de saúde:</mat-label>
                    <textarea matInput #problemaSaude name="problemaSaude" [(ngModel)]="pessoaFisica.problemaSaude"
                              cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                              maxlength="200"></textarea>
                    <mat-hint align="end">{{ problemaSaude.value.length }} / 200</mat-hint>
                </mat-form-field>

                <mat-form-field fxFlex="50%" appearance="outline">
                    <mat-label>Descrição dos medicamentos controlados utilizados:</mat-label>
                    <textarea matInput #medicamentosControlados name="medicamentosControlados"
                              [(ngModel)]="pessoaFisica.medicamentosControlados" cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="3" maxlength="200"></textarea>
                    <mat-hint align="end">{{ medicamentosControlados.value.length }} / 200</mat-hint>
                </mat-form-field>
            </div>

        </div>

    </div>

    <documentos-aluno [pessoaFisica]="pessoaFisica" [validaCPF]="false" [apresentaCPF]="false"></documentos-aluno>

    <!-- ETAPA 1 - ENDEREÇO -->
    <cadastro-endereco [dadosEndereco]="pessoaFisica"></cadastro-endereco>

    <!-- ETAPA 1 - CONTATO -->
    <mat-toolbar class="titulopartes">Contato</mat-toolbar>
    <!-- LINHA DE TELEFONES RESIDENCIAIS -->
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center" fxFlexFill>
        <!-- Metade esquerda: telefone residencial -->
        <div fxFlex="48" fxLayout="row" fxLayoutGap="10px">

            <mat-form-field fxFlex="16.00">
                <input matInput [(ngModel)]="pessoaFisica.telefoneResidencial" name="telefoneResidencial" placeholder="Telefone Residencial"
                    [textMask]="{ mask: maskPhone }" pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$">
            </mat-form-field>

            <combo-grau-parentesco fxFlex="19.00" [selecionado]="pessoaFisica.descricaoParentescoTelefoneResidencial"
                [obrigatorio]="false" [label]="'Referência'" (valorChange)="onDescricaoParentescoTelefoneResidencialChange($event)">
            </combo-grau-parentesco>

            <mat-form-field fxFlex="65.00">
                <input matInput maxlength="150" [(ngModel)]="pessoaFisica.parentescoTelefoneResidencial" name="parentescoTelefoneResidencial" placeholder="Contato">
            </mat-form-field>

        </div>

        <!-- Metade direita: telefone para recado -->
        <div fxFlex="48" fxLayout="row" fxLayoutGap="10px">

            <mat-form-field fxFlex="16.00">
                <input matInput [(ngModel)]="pessoaFisica.foneRecado" name="nr_fone_recado" placeholder="Telefone Recado"
                    [textMask]="{ mask: maskPhone }" pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$">
            </mat-form-field>

            <combo-grau-parentesco fxFlex="19.00" [selecionado]="pessoaFisica.descricaoParentescoFoneRecado"
                [obrigatorio]="false" [label]="'Referência'" (valorChange)="onDescricaoParentescoFoneRecadoChange($event)">
            </combo-grau-parentesco>

            <mat-form-field fxFlex="65.00">
                <input matInput maxlength="150" [(ngModel)]="pessoaFisica.parentescoFoneRecado" name="parentescoFoneRecado" placeholder="Contato">
            </mat-form-field>

        </div>

    </div>

    <!-- LINHA DE CELULARES 1 E 2 -->
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center" fxFlexFill>
        <!-- Metade esquerda: celular 1 -->
        <div fxFlex="48" fxLayout="row" fxLayoutGap="10px">

            <mat-form-field fxFlex="16.00">
                <input matInput [(ngModel)]="pessoaFisica.celular" name="celular" placeholder="Celular"
                    [textMask]="{mask: maskCelular}"
                    pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$">
            </mat-form-field>

            <combo-grau-parentesco fxFlex="19.00" [selecionado]="pessoaFisica.descricaoParentescoCelular"
                [obrigatorio]="false" [label]="'Referência'" (valorChange)="onDescricaoParentescoCelularChange($event)">
            </combo-grau-parentesco>

            <mat-form-field fxFlex="65.00">
                <input matInput maxlength="150" [(ngModel)]="pessoaFisica.parentescoFoneCelular" name="parentescoFoneCelular" placeholder="Contato">
            </mat-form-field>

        </div>

        <!-- Metade direita: celular 2 -->
        <div fxFlex="48" fxLayout="row" fxLayoutGap="10px">

            <mat-form-field fxFlex="16.00">
                <input matInput [(ngModel)]="pessoaFisica.celular2" name="nr_fone_celular_2"
                    placeholder="Celular 2"
                    [textMask]="{mask: maskCelular}"
                    pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$">
            </mat-form-field>

            <combo-grau-parentesco fxFlex="19.00"
                                [selecionado]="pessoaFisica.descricaoParentescoCelular2"
                                [obrigatorio]="false"
                                [label]="'Referência'"
                                (valorChange)="onDescricaoParentescoCelular2Change($event)">
            </combo-grau-parentesco>

            <mat-form-field fxFlex="65.00">
                <input matInput maxlength="150" [(ngModel)]="pessoaFisica.parentescoFoneCelular2" name="parentescoFoneCelular2" placeholder="Contato">
            </mat-form-field>

        </div>

    </div>

    <!-- LINHA DE CELULAR 3 E DE EMAIL -->
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center" fxFlexFill>
        <!-- Metade esquerda: celular 3 -->
        <div fxFlex="48" fxLayout="row" fxLayoutGap="10px">

            <mat-form-field fxFlex="16.00">
                <input matInput [(ngModel)]="pessoaFisica.celular3" name="nr_fone_celular_3" placeholder="Celular 3"
                    [textMask]="{mask: maskCelular}" pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$">
            </mat-form-field>

            <combo-grau-parentesco fxFlex="19.00" [selecionado]="pessoaFisica.descricaoParentescoCelular3"
                [obrigatorio]="false" [label]="'Referência'" (valorChange)="onDescricaoParentescoCelular3Change($event)">
            </combo-grau-parentesco>

            <mat-form-field fxFlex="65.00">
                <input matInput maxlength="150" [(ngModel)]="pessoaFisica.parentescoFoneCelular3" name="parentescoFoneCelular3" placeholder="Contato">
            </mat-form-field>

        </div>

        <!-- Metade direita: EMAIL -->
        <div fxFlex="48" fxLayout="row" fxLayoutGap="10px">

            <mat-form-field fxFlex="47.00">
                <input maxlength="100" matInput [(ngModel)]="pessoaFisica.email" type="email" name="email" placeholder="Email:" email>
            </mat-form-field>

            <combo-grau-parentesco fxFlex="19.00" [selecionado]="pessoaFisica.descricaoParentescoEmail"
                [obrigatorio]="false" [label]="'Referência'" (valorChange)="onDescricaoParentescoEmailChange($event)">
            </combo-grau-parentesco>

            <div fxFlex="34.00">
                <div style="margin-top: 25px;">
                    <mat-checkbox color="primary" name="autorizaEmail" [(ngModel)]="pessoaFisica.autorizaEmail">Autorizo o recebimento de emails.</mat-checkbox>
                </div>
            </div>

        </div>

    </div>

    <!--  lINHA PARA TELEFONES IMPORTACAO   -->
    <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field fxFlexOffset="20px" fxFlex>
            <input matInput [(ngModel)]="pessoaFisica.contatoImportacao" name="ds_contato_importacao"
                   placeholder="Telefone Importação">
        </mat-form-field>

        <mat-form-field fxFlex>
            <input matInput [(ngModel)]="pessoaFisica.foneFamiliarImportacao" name="ds_fone_familiar_imp"
                   placeholder="Telefone Importação Responsável">
        </mat-form-field>
    </div>
</div>
